// extracted by mini-css-extract-plugin
export var Partnercontainer = "Certificate-module--Partnercontainer--G6aOb";
export var breadcrumbWrapper = "Certificate-module--breadcrumbWrapper--gRux7";
export var certificateBanner = "Certificate-module--certificateBanner--G91rU";
export var certificateContainer = "Certificate-module--certificateContainer--A6E-Q";
export var certificateSection = "Certificate-module--certificateSection--MW9J6";
export var errorWrapper = "Certificate-module--errorWrapper--UcZsa";
export var headerx = "Certificate-module--headerx--AvYqc";
export var hideOnMobile = "Certificate-module--hideOnMobile--YTmm3";
export var leftSection = "Certificate-module--leftSection--dmQZm";
export var logoContainer = "Certificate-module--logoContainer--zP3oO";
export var moduleInfoBreadcrumb = "Certificate-module--moduleInfoBreadcrumb--Mu4XL";
export var moduleNameBreadcrumb = "Certificate-module--moduleNameBreadcrumb--gxB2g";
export var partnerBanner = "Certificate-module--partnerBanner--YAlAy";
export var partnerReviewSection = "Certificate-module--partnerReviewSection--zHzpg";
export var rightSection = "Certificate-module--rightSection--FA0DH";
export var shawBtn = "Certificate-module--shawBtn--ScVBV";
export var showOnMobile = "Certificate-module--showOnMobile--c2-yb";
export var showOnMobileFlex = "Certificate-module--showOnMobileFlex--CzbQE";
export var subscribeSection = "Certificate-module--subscribeSection--u6SUK";
export var subscribeSectionContainer = "Certificate-module--subscribeSectionContainer--5cYGu";
export var svgMainWrapper = "Certificate-module--svgMainWrapper--7aNxe";
export var svgMainWrapperMobile = "Certificate-module--svgMainWrapperMobile--fInhr";
export var svgSection = "Certificate-module--svgSection--GjFh9";
export var userHeading = "Certificate-module--userHeading--cFC5s";
export var userName = "Certificate-module--userName--yVhU2";
export var userReviews = "Certificate-module--userReviews--TkfOz";
export var userReviewsOuterContainer = "Certificate-module--userReviewsOuterContainer--ES1+l";